import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import TruncatedPages from "./TruncatedPages"; // eslint-disable-line
import { useMediaQuery } from "react-responsive";

/*
 ** Station for pagination
 */

const Pagination = ({
	handleDecrementPage,
	handleIncrementPage,
	totalPages,
	handleButtonPageSelect,
	currentPageNumber,
}) => {
	const [truncatedPages, setTruncatedPages] = useState([]);

	const isDesktopOrLaptop = useMediaQuery({
		query: "(min-width: 1224px)",
	});

	const delta = isDesktopOrLaptop ? 2 : 1;
	const truncatePages = (current, last, delta) => {
		let left = current - delta,
			right = current + delta + 1,
			range = [],
			rangeWithDots = [],
			l;

		for (let i = 1; i <= last; i++) {
			if (i == 1 || i == last || (i >= left && i < right)) {
				range.push(i);
			}
		}

		for (let i of range) {
			if (l) {
				if (i - l === 2) {
					rangeWithDots.push(l + 1);
				} else if (i - l !== 1) {
					rangeWithDots.push("...");
				}
			}
			rangeWithDots.push(i);
			l = i;
		}
		return rangeWithDots;
	};

	useEffect(() => {
		const lastPage = totalPages.slice(-1).pop();
		setTruncatedPages(truncatePages(currentPageNumber, lastPage, delta));
	}, [totalPages, currentPageNumber]);

	return (
		<div className="pagination-react">
			<div className="pagination-react__wrapper">
				<a
					className={`prev${currentPageNumber === 1 ? " disable" : ""}`}
					onClick={() => {
						handleDecrementPage();
					}}
				></a>
				<TruncatedPages
					truncatedPages={truncatedPages}
					handleButtonPageSelect={handleButtonPageSelect}
					currentPageNumber={currentPageNumber}
				/>
				<a
					className={`next ${
						currentPageNumber === totalPages.length ? " disable" : ""
					}`}
					onClick={() => {
						handleIncrementPage();
					}}
				></a>
			</div>
		</div>
	);
};

Pagination.propTypes = {
	handleDecrementPage: PropTypes.func,
	handleIncrementPage: PropTypes.func,
	totalPages: PropTypes.array,
	handleButtonPageSelect: PropTypes.func,
	currentPageNumber: PropTypes.number,
};

export default Pagination;
